// Good Knee — main application JS

// Sticky buy bar
(function () {
  const bar = document.getElementById('sticky-buy');
  if (!bar) return;
  window.addEventListener('scroll', function () {
    bar.classList.toggle('show', window.scrollY > 800);
  }, { passive: true });
})();

// Exploded view scroll-linked animation
(function () {
  const wrap = document.querySelector('.exploded-wrap');
  const device = document.getElementById('exploded-device');
  const dots = document.querySelectorAll('.exploded-progress-dot');
  const labels = document.querySelectorAll('.ex-label');
  const cards = document.querySelectorAll('.exploded-steps .step-card');
  if (!wrap || !device) return;

  // Bail on mobile — the section is a simple static stack there, no scroll work needed.
  const mobileQuery = window.matchMedia('(max-width: 900px)');
  if (mobileQuery.matches) {
    device.style.transform = '';
    return;
  }

  let ticking = false;

  function update() {
    ticking = false;
    const rect = wrap.getBoundingClientRect();
    const vh = window.innerHeight;
    const total = rect.height - vh;
    if (total <= 0) return;
    const scrolled = Math.min(Math.max(-rect.top, 0), total);
    const progress = scrolled / total;

    // Smooth parallax on the exploded image (scale/translate)
    const ty = progress * -28;
    const sc = 1 + progress * 0.04;
    device.style.transform = 'translateY(' + ty.toFixed(2) + 'px) scale(' + sc.toFixed(3) + ')';

    // Progress dots — cumulative fill as each card segment is reached
    const steps = dots.length || 4;
    const dotPhase = Math.min(Math.floor(progress * steps + 0.001), steps - 1);
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i <= dotPhase);
    });

    // Pointer labels — activate progressively, first label fires as soon as
    // the section pins, last label fires by ~85% so all 6 are visible before
    // the user scrolls out the bottom.
    if (labels.length) {
      // A little hysteresis: each label has a threshold slightly before its slot
      // so the reveal feels anticipatory rather than laggy.
      const span = 0.82;
      labels.forEach(function (l, i) {
        const threshold = (i / labels.length) * span;
        l.classList.toggle('is-active', progress >= threshold);
      });
    }
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Also sync step-card "in view" state (useful for any future card-level styling)
  if ('IntersectionObserver' in window && cards.length) {
    const cardObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-in-view', e.isIntersecting);
      });
    }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });
    cards.forEach(function (c) { cardObs.observe(c); });
  }

  update();
})();

// Quiz
(function () {
  const wrap = document.getElementById('knee-quiz');
  if (!wrap) return;

  const QUESTIONS = [
    {
      label: 'Q1 / Lifestyle',
      q: 'How often do your knees click on stairs?',
      opts: [
        { tag: 'NEVER', text: 'Silent. Smooth. Annoyingly so.', score: 0 },
        { tag: 'SOMETIMES', text: 'A pop here. A crack there.', score: 2 },
        { tag: 'OFTEN', text: 'Flights are a percussion section.', score: 4 },
        { tag: 'ALWAYS', text: 'I am the soundtrack.', score: 6 }
      ]
    },
    {
      label: 'Q2 / Training',
      q: 'How many sessions per week?',
      opts: [
        { tag: '0\u20131', text: "I'm on a break. A long one.", score: 1 },
        { tag: '2\u20133', text: 'Moderate. I touch grass.', score: 2 },
        { tag: '4\u20135', text: 'Religious. Sweaty. Consistent.', score: 4 },
        { tag: '6+', text: 'I am the algorithm.', score: 6 }
      ]
    },
    {
      label: 'Q3 / Daily Load',
      q: 'Sitting vs standing in a workday?',
      opts: [
        { tag: 'DESK', text: 'Chair-shaped. 8+ hrs.', score: 5 },
        { tag: 'HYBRID', text: 'Standing desk, sometimes.', score: 3 },
        { tag: 'ACTIVE', text: 'On my feet most of the day.', score: 2 },
        { tag: 'ATHLETE', text: 'Movement is the job.', score: 1 }
      ]
    },
    {
      label: 'Q4 / Recovery',
      q: "What's your post-workout ritual?",
      opts: [
        { tag: 'NONE', text: 'Shower. Scroll. Collapse.', score: 5 },
        { tag: 'STRETCH', text: 'Ten minutes of hamstrings.', score: 3 },
        { tag: 'ROLL', text: 'Foam roller + cold shower.', score: 2 },
        { tag: 'PROTOCOL', text: 'Sauna, ice, the full thing.', score: 1 }
      ]
    }
  ];

  let currentStep = 0;
  const answers = [null, null, null, null];

  const progressDots = wrap.querySelectorAll('.quiz-progress span');
  const steps = wrap.querySelectorAll('.quiz-step');
  const resultEl = wrap.querySelector('.quiz-result');
  const backBtn = wrap.querySelector('.quiz-back');

  function updateProgress() {
    progressDots.forEach(function (dot, i) {
      dot.className = i < currentStep ? 'done' : i === currentStep ? 'active' : '';
    });
  }

  function showStep(n) {
    steps.forEach(function (s, i) {
      s.classList.toggle('active', i === n);
    });
    if (resultEl) resultEl.classList.remove('active');
    updateProgress();
    if (backBtn) backBtn.style.opacity = n === 0 ? '0.35' : '1';
  }

  function showResult() {
    steps.forEach(function (s) { s.classList.remove('active'); });
    if (!resultEl) return;
    resultEl.classList.add('active');

    const total = answers.reduce(function (sum, a, i) {
      return sum + (a == null ? 0 : QUESTIONS[i].opts[a].score);
    }, 0);

    const kneeAge = Math.round(20 + (total / 23) * 60);
    const verdict =
      kneeAge < 30 ? 'Built Different' :
      kneeAge < 45 ? 'Holding The Line' :
      kneeAge < 60 ? 'Clicky But Fixable' :
      'Maintenance Overdue';

    const protocol =
      kneeAge < 30
        ? '5-minute sessions, 2\u00d7 per week. Heat 1 + Vibe 1. Keep the streak going \u2014 prevention is the whole game.'
        : kneeAge < 45
        ? '10-minute sessions, 3\u00d7 per week after training. Heat 2 + Vibe 2 + IR. Sunday reset recommended.'
        : kneeAge < 60
        ? '15-minute sessions, daily. Heat 3 + Vibe 2 + IR. Stack with a foam roller on the rough days.'
        : '20-minute sessions, morning and evening. Full-protocol. Heat 3 + Vibe 3 + IR. Your knees are asking politely.';

    const hugeEl = resultEl.querySelector('.huge');
    const verdictEl = resultEl.querySelector('.verdict');
    const protocolEl = resultEl.querySelector('.protocol');
    if (hugeEl) hugeEl.textContent = kneeAge;
    if (verdictEl) verdictEl.textContent = verdict;
    if (protocolEl) protocolEl.textContent = protocol;

    // Scorecard
    const scorecard = resultEl.querySelector('.quiz-scorecard');
    if (scorecard) {
      scorecard.innerHTML = QUESTIONS.map(function (q, i) {
        const pick = answers[i] != null ? q.opts[answers[i]].tag : '\u2014';
        return '<div class="quiz-scorecard-item"><div class="quiz-scorecard-label">' + q.label + '</div><div class="quiz-scorecard-val">' + pick + '</div></div>';
      }).join('');
    }

    progressDots.forEach(function (dot) { dot.className = 'done'; });
  }

  // Option buttons
  wrap.querySelectorAll('.quiz-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const stepEl = btn.closest('.quiz-step');
      const stepIndex = parseInt(stepEl.dataset.step, 10);
      const optIndex = parseInt(btn.dataset.opt, 10);

      // Mark selected
      stepEl.querySelectorAll('.quiz-option').forEach(function (b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      answers[stepIndex] = optIndex;

      setTimeout(function () {
        if (stepIndex < QUESTIONS.length - 1) {
          currentStep = stepIndex + 1;
          showStep(currentStep);
        } else {
          showResult();
        }
      }, 280);
    });
  });

  // Back button
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    });
  }

  // Retake
  const retakeBtn = resultEl && resultEl.querySelector('.quiz-retake');
  if (retakeBtn) {
    retakeBtn.addEventListener('click', function () {
      answers.fill(null);
      currentStep = 0;
      wrap.querySelectorAll('.quiz-option').forEach(function (b) { b.classList.remove('selected'); });
      showStep(0);
    });
  }

  // Init
  showStep(0);
})();
